import { render, staticRenderFns } from "./PaymentBonusDetailsTable.vue?vue&type=template&id=ff1bc04e&scoped=true&"
import script from "./PaymentBonusDetailsTable.vue?vue&type=script&lang=js&"
export * from "./PaymentBonusDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBonusDetailsTable.vue?vue&type=style&index=0&id=ff1bc04e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1bc04e",
  null
  
)

export default component.exports